module.exports = __webpack_public_path__ + "static/media/sort-arrow-up-active.9b6ef765.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Kendra/images/sort-arrow-up-active.svg
// module id = 3241
// module chunks = 0